
export const termsConditions = (payload: any) => async (dispatch: any) => {
  dispatch({
    type: 'TERMS_CONDITIONS',
    payload
  })
}
